var Component = require("!../../node_modules/_vue-loader@12.2.1@vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/_vue-loader@12.2.1@vue-loader/lib/selector?type=script&index=0!./SignUpForm.vue"),
  /* template */
  require("!!../../node_modules/_vue-loader@12.2.1@vue-loader/lib/template-compiler/index?{\"id\":\"data-v-47bb669e\"}!../../node_modules/_vue-loader@12.2.1@vue-loader/lib/selector?type=template&index=0!./SignUpForm.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/SignUpForm.vue
// module id = 76
// module chunks = 1